import { render, staticRenderFns } from "./MPage.vue?vue&type=template&id=ed6daee0&scoped=true&"
import script from "./MPage.vue?vue&type=script&lang=js&"
export * from "./MPage.vue?vue&type=script&lang=js&"
import style0 from "./MPage.vue?vue&type=style&index=0&id=ed6daee0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed6daee0",
  null
  
)

export default component.exports